import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Modal, Toast } from 'bootstrap';
import { AuthService } from '../services/auth.service';
import { BookingService } from '../services/booking.service';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { getBoatImageUrl } from '../utils/image-url.util';

// Tambahkan deklarasi untuk intlTelInput dengan tipe yang lebih spesifik
declare var intlTelInput: {
  (
    element: HTMLElement,
    options?: {
      initialCountry?: string;
      separateDialCode?: boolean;
      loadUtilsOnInit?: boolean; // Gantikan utilsScript dengan loadUtilsOnInit
      // Tambahkan opsi lain sesuai kebutuhan
    },
  ): any;
};

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css'],
})
export class BookingComponent implements OnInit {
  @ViewChild('phoneInput') phoneInput!: ElementRef;
  // Tambahkan variabel untuk menyimpan instance intlTelInput
  private intlTelInputInstance: any;

  bookingData: any;
  private Delmodal!: Modal;
  private Resmodal!: Modal;
  private Restoast!: Toast;

  id_pelanggan: any;

  idpel: number | null = null;
  setAcc: string = '';
  pelangganForm!: FormGroup;
  errorMessage: string = '';
  submitted = false;

  bankList: { value: string; display: string }[] = [
    { value: 'BNI', display: 'Bank Negara Indonesia (BNI)' },
    { value: 'BSI', display: 'Bank Syariah Indonesia (BSI)' },
    { value: 'BRI', display: 'Bank Rakyat Indonesia (BRI)' },
    { value: 'CIMB', display: 'CIMB Niaga' },
    { value: 'PERMATA', display: 'Permata Bank' },
    { value: 'MANDIRI', display: 'Bank Mandiri' },
  ];

  user: {
    name: string;
    email: string;
    photo: string;
    user_login: string;
    user_wa: string;
  } | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private location: Location,
    public authService: AuthService,
    public bookService: BookingService,
  ) {
    this.initializeForms();
  }

  private initializeForms() {
    this.pelangganForm = this.fb.group({
      fullName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]{10,13}$')]],
      notes: [''],
      paymentMethod: ['', Validators.required],
      bankName: [''], // validator dinamis
    });
  }

  // Safely get form control with null check
  getFormControl(form: FormGroup, controlName: string): AbstractControl | null {
    return form.get(controlName);
  }

  // Safely check if control has specific error
  hasError(form: FormGroup, controlName: string, errorType: string): boolean {
    const control = this.getFormControl(form, controlName);
    return control ? this.submitted && control.hasError(errorType) : false;
  }

  getImageUrl(path: string): string {
    return getBoatImageUrl(path);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  getAccomodationText(): string {
    if (this.bookingData?.accomodations?.length > 0) {
      return this.bookingData.accomodations
        .map((acc: any) => acc.name)
        .join(', ');
    } else {
      return 'Entire Place';
    }
  }

  onPaymentMethodChange(): void {
    this.pelangganForm
      .get('paymentMethod')
      ?.valueChanges.subscribe((method) => {
        const bankControl = this.pelangganForm.get('bankName');

        if (method === 'transfer') {
          bankControl?.setValidators([Validators.required]);
        } else {
          bankControl?.clearValidators();
          bankControl?.setValue('');
        }

        bankControl?.updateValueAndValidity();
      });
  }

  ngOnInit(): void {
    // Periksa apakah pengguna sudah login
    if (!this.authService.isLoggedIn2()) {
      // Simpan halaman saat ini sebagai rute asal
      this.authService.setRedirectUrl(this.router.url);
    }

    setTimeout(() => {
      this.Delmodal = new Modal(document.getElementById('confirmRemoveModal')!);
      this.Resmodal = new Modal(
        document.getElementById('confirmReservasiModal')!,
      );
      this.Restoast = new Toast(document.getElementById('reservationToast')!);
    });

    // Mengambil data dari localStorage
    const storedData = localStorage.getItem('formattedBookingData');
    if (storedData) {
      this.bookingData = JSON.parse(storedData);

      this.setAcc = this.getAccomodationText();
    }

    const userName = localStorage.getItem('user_name');
    const userEmail = localStorage.getItem('user_email');
    const userPhoto = localStorage.getItem('user_photo');
    const userLogin = localStorage.getItem('user_login');
    const userWa = localStorage.getItem('user_wa');

    if (userName && userEmail && userLogin) {
      this.user = {
        name: userName,
        email: userEmail,
        photo: userPhoto || '',
        user_login: userLogin,
        user_wa: userWa || '',
      };
      // console.log(this.user);

      this.pelangganForm.patchValue({
        fullName: this.user.name,
        email: this.user.email,
      });

      this.authService.getPelangganByEmail(userEmail).subscribe(
        (res) => {
          const phoneNumber = res.whatsapp_number || '';
          //   if (phoneNumber) {
          //  // Fungsi untuk memisahkan kode negara

          //   }

          this.initializePhoneInput();
          this.setPhoneNumber(phoneNumber);

          const idpel = res.id;
          if (idpel) {
            this.idpel = idpel; // Fungsi untuk memisahkan kode negara
          }
        },
        (error) => {
          this.errorMessage = 'Failed to load bookings';
          console.error(error);
        },
      );

      // Set default values in form
    }

    this.onPaymentMethodChange();
  }

  private setPhoneNumber(fullPhoneNumber: string) {
    if (!this.intlTelInputInstance) return;

    this.intlTelInputInstance.setNumber(fullPhoneNumber); // Gunakan intlTelInput untuk mengatur nomor

    const countryData = this.intlTelInputInstance.getSelectedCountryData();
    const dialCode = `+${countryData.dialCode}`;

    // Ambil hanya nomor tanpa kode negara
    const phoneWithoutDialCode = fullPhoneNumber.replace(dialCode, '').trim();

    // Atur nilai input secara manual
    this.pelangganForm.patchValue({
      phone: phoneWithoutDialCode,
    });
  }

  // Fungsi untuk kembali ke halaman sebelumnya
  goBack(event: Event): void {
    event.preventDefault();

    const tripKategori = this.bookingData.trip_kategori;
    let basePath = '';

    if (tripKategori === 'Open Trip Komodo National Park') {
      basePath = '/detail-boatopen';
    } else if (tripKategori === 'Boat Charter') {
      basePath = '/detail-boat';
    } else if (tripKategori === 'Open Trip Outside Komodo') {
      basePath = '/detail-boatoutside';
    } else {
      // fallback jika kategori tidak diketahui
      console.warn('Unknown trip category:', tripKategori);
      return;
    }

    const formattedName = this.bookingData.nama_kapal
      .toLowerCase()
      .replace(/\s+/g, '-') // ganti spasi dengan '-'
      .replace(/[^\w-]+/g, ''); // hapus karakter tidak valid

    this.router.navigate([basePath, formattedName]);

    // this.location.back();
  }

  // Fungsi untuk menghapus booking data
  removeBookingData(event: Event): void {
    event.preventDefault();
    this.Delmodal.show();
  }

  confirmRemoveBooking(): void {
    // localStorage.removeItem('formattedBookingData');
    this.authService.removeBookingData();
    this.bookingData = null; // Reset data di halaman
    this.Delmodal.hide();
  }

  // Fungsi untuk memuat script intlTelInput secara dinamis
  // private loadIntlTelInputScript() {
  //   if (!(window as any).intlTelInput) {
  //     const script = document.createElement('script');
  //     script.src = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js';
  //     script.onload = () => {
  //       const utilsScript = document.createElement('script');
  //       utilsScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js';
  //       document.head.appendChild(utilsScript);
  //     };
  //     document.head.appendChild(script);
  //   }
  // }

  // Fungsi untuk inisialisasi input telepon
  private initializePhoneInput() {
    if (this.phoneInput && (window as any).intlTelInput) {
      const input = this.phoneInput.nativeElement;

      if (this.intlTelInputInstance) {
        this.intlTelInputInstance.destroy();
      }

      this.intlTelInputInstance = intlTelInput(input, {
        initialCountry: 'id',
        separateDialCode: true,
        loadUtilsOnInit: true, // Menghapus utilsScript yang sudah deprecated
      });
    }
  }

  no_wa: string = '';

  reservasi(): void {
    this.submitted = true;

    if (this.pelangganForm.valid && this.bookingData) {
      const countryData = this.intlTelInputInstance.getSelectedCountryData();
      const dialCode = countryData.dialCode;
      const phoneNumber = this.pelangganForm.value.phone;
      this.no_wa = `+${dialCode}${phoneNumber.replace(/\D/g, '')}`;

      const email = this.pelangganForm.value.email;
      if (this.idpel) {
        this.authService.checkWhatsAppNumber(this.no_wa, this.idpel).subscribe(
          (res) => {
            if (res.hasil) {
              // Nomor WA sudah terdaftar, tampilkan error
              this.pelangganForm
                .get('phone')
                ?.setErrors({ alreadyExists: true });
            } else {
              // Nomor WA belum terdaftar, lanjutkan reservasi
              this.authService
                .updatePhoneNumber(email, this.no_wa)
                .subscribe(() => {
                  this.Resmodal.show(); // Tampilkan modal konfirmasi reservasi
                });
            }
          },
          (error) => {
            console.error('Error checking WhatsApp number:', error);
          },
        );
      }
    }
  }

  submitReservation(): void {
    if (this.pelangganForm.valid && this.bookingData) {
      const pelangganData = {
        fullName: this.pelangganForm.value.fullName,
        email: this.pelangganForm.value.email,
        phone: this.pelangganForm.value.phone,
      };

      this.authService.get_id(this.pelangganForm.value.email).subscribe(
        (response) => {
          const id_pelanggan = response.id;

          // Format tanggal
          const [startDateStr, endDateStr] =
            this.bookingData.startDate.split(' - ');
          const formatDate = (date: string): string =>
            new Date(date.trim()).toLocaleDateString('en-CA');
          const startDate = formatDate(startDateStr);
          const endDate = formatDate(endDateStr);

          // Ambil destinasi
          let tuj: string = '';
          tuj = this.isArray(this.bookingData.destination)
            ? this.bookingData.destination[0].tuj
            : this.bookingData.destination;

          // Jenis layanan
          const jl: string = this.bookingData.accomodations
            ? tuj
            : this.bookingData.boat_kategori;

          // Ambil metode pembayaran
          const paymentMethodRaw =
            this.pelangganForm.get('paymentMethod')?.value;
          const bankValue = this.pelangganForm.get('bankName')?.value;

          // Jika credit card, tetap gunakan 'credit card', jika transfer maka kirim nama bank
          const paymentMethod =
            paymentMethodRaw === 'credit card' ? 'credit card' : bankValue;

          // Hitung biaya credit card dan total final
          let originalTotal = this.bookingData.total;

          // Pastikan number
          if (typeof originalTotal === 'string') {
            originalTotal = parseInt(originalTotal.replace(/,/g, ''), 10);
          }

          const isCreditCard = paymentMethod === 'credit card';
          const creditCardFee = isCreditCard
            ? Math.round(originalTotal * 0.03)
            : 0;
          const finalTotal = originalTotal + creditCardFee;

          const reservationData: any = {
            id_pelanggan: id_pelanggan,
            nama_kapal: this.bookingData.nama_kapal,
            trip_kategori: this.bookingData.trip_kategori,
            boat_kategori: this.bookingData.boat_kategori,
            gambar_kapal: this.bookingData.gambar_kapal['gambar'],
            destinasi: tuj,
            durasi: this.bookingData.duration,
            start_date: startDate,
            end_date: endDate,
            guests: this.guestsCount,
            notes: this.pelangganForm.value.notes,
            jenis_layanan: jl,
            metode_pembayaran: paymentMethod,
            credit_card_fee: creditCardFee,
            total: finalTotal,
            accomodation_details: Array.isArray(this.bookingData.accomodations)
              ? this.bookingData.accomodations.map((acc: any) => ({
                  name: acc.name,
                  price: acc.price,
                }))
              : [],
          };

          // console.log(reservationData);

          this.bookService.createBooking(reservationData).subscribe(
            (response) => {
              console.log('Reservasi berhasil disimpan:', response);
              this.authService.removeBookingData();
              this.bookingData = null;
              this.Resmodal.hide();
              this.Restoast.show();
              setTimeout(() => this.router.navigate(['/checkout']), 3000);
            },
            (error) => {
              console.error('Gagal menyimpan reservasi:', error);
            },
          );
        },
        (error) => {
          console.error('Gagal mendapatkan ID pelanggan:', error);
        },
      );
    }
  }

  get filteredBankList() {
    const total = this.bookingData?.total || 0;

    // Jika total dalam bentuk string, ubah ke number
    const numericTotal =
      typeof total === 'string' ? parseInt(total.replace(/,/g, ''), 10) : total;

    return this.bankList.filter((bank) => {
      if (bank.value === 'CIMB') {
        return numericTotal >= 10000 && numericTotal <= 50000000000;
      }
      return true;
    });
  }

  get finalTotal(): number {
    const baseTotal = this.bookingData?.total || 0;
    const method = this.pelangganForm?.get('paymentMethod')?.value;
    return method === 'credit card' ? Math.round(baseTotal * 1.03) : baseTotal;
  }

  get isCreditCardSelected(): boolean {
    return this.pelangganForm?.get('paymentMethod')?.value === 'credit card';
  }

  get creditCardFee(): number {
    const total = this.bookingData?.total || 0;
    return this.isCreditCardSelected ? Math.round(total * 0.03) : 0;
  }

  get guestsCount(): number {
    const guestsString = this.bookingData?.guests || '';
    const match = guestsString.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }
}
